import { Brand, createBranded } from '@deltasierra/type-utilities';

export type FacebookPageId = Brand<string, 'FacebookPageId'>;
export const FacebookPageId = createBranded<FacebookPageId>();

export type FacebookPostId = Brand<string, 'FacebookPostId'>;
export const FacebookPostId = createBranded<FacebookPostId>();

export type FacebookPagePostId = Brand<string, 'FacebookPagePostId'>;

export namespace FacebookPagePostId {
    export function from(value: string): FacebookPagePostId;
    export function from(pageId: FacebookPageId, postId: FacebookPostId): FacebookPagePostId;
    export function from(
        ...args: [pageId: FacebookPageId, postId: FacebookPostId] | [value: string]
    ): FacebookPagePostId {
        if (isFromRaw(args)) {
            return args[0] as FacebookPagePostId;
        } else {
            const [pageId, postId] = args;
            return `${pageId}_${postId}` as FacebookPagePostId;
        }
    }
}

function isFromRaw(value: unknown): value is [value: string] {
    return Array.isArray(value) && value.length === 1 && typeof value[0] === 'string';
}
